// styles.js
import styled, { keyframes } from 'styled-components'

const showModal = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`

export const Background = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  animation: ${showModal} 200ms;
  overflow: hidden;
`

export const ModalWrapper = styled.div`
  max-width: 420px;
  width: 100%;
  background: #fff;
  color: #000;
  position: relative;
  z-index: 1001;
  border-radius: 4px;
  max-height: 95%;
  overflow-y: auto;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.2);

  @media (max-width: 560px) {
    max-width: 90%;
  }

  @media (max-height: 550px) {
    max-height: 95%;
    overflow-y: scroll;
  }
`

export const HeaderModalClose = styled.button`
  background: none;
  border: 0;
  position: absolute;
  top: 18px;
  right: 18px;
  cursor: pointer;

  img {
    width: 14px;
    height: 14px;
  }

  &:hover {
    opacity: 0.6;
  }
`

export const ModalContent = styled.div`
  padding: 40px 32px 32px;
`

export const Title = styled.h2`
  color: #d22630;
  margin-bottom: 10px;
  font-size: 17px;
  font-weight: 500;

  @media (max-width: 480px) {
    font-size: 15px;
  }
`

export const Subtitle = styled.p`
  margin-bottom: 25px;
  font-size: 12px;
  @media (max-width: 480px) {
    font-size: 11px;
  }
`

export const InputContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
`

export const InputCode = styled.input`
  width: 40px;
  height: 40px;
  text-align: center;
  font-size: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  @media (max-width: 480px) {
    width: 30px;
    height: 40px;
    font-size: 16px;
  }
`

export const StatusMsg = styled.p`
  font-size: 10px;
  margin-bottom: 10px;
  color: #333;
  @media (max-width: 480px) {
    font-size: 9px;
  }
`

export const ErrorMsg = styled.p`
  font-size: 10px;
  margin-bottom: 10px;
  color: #d22630;
  @media (max-width: 480px) {
    font-size: 9px;
  }
`

export const ResendMsg = styled.p`
  font-size: 10px;
  margin-top: 5px;
  font-weight: 500;
  @media (max-width: 480px) {
    font-size: 9px;
  }
`

export const ResendLink = styled.span`
  font-size: 10px;
  margin-top: 5px;
  color: #d22630;
  cursor: pointer;
  @media (max-width: 480px) {
    font-size: 9px;
  }

  &:hover {
    text-decoration: underline;
  }
`
